import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Postrequestcall } from "../../../request/Postrequest";
import { useSelector } from "react-redux";
import { FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT } from "../../../constant/Apipath";
import Getcurrentlocation from "../../../common/Getcurrentlocation";
import Loader from "../../../common/Loader";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import { BIGrey } from "../../../assets/helpers";

let CLIENT_COLOR = "#000000";

const SelectJob = ({
  isOpen,
  onClose,
  setInputValue,
  selectedValue,
  setSelectedValue,
  setSelectActivities,
  setFromjob
}) => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);

  const TOKEN = loginData?.accessToken;
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const CLIENT_ID = selectedClientData?.ClientId;

  const { TEXT_SORT_BY, TEXT_NEAR_BY, TEXT_RECENT, TEXT_SELECT_JOB, TEXT_NO_JOBS_FOUND } =
    ClientEnglishFallback?.SelectJobModal(multiLanguageData?.SelectJobModal || {});

  const [clientJobList, setClientJobList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sortByNearby, setSortByNearby] = useState(false);

  useEffect(() => {
    if (isOpen === true) {
      getClientJobs();
    }
  }, [isOpen, sortByNearby]);

  const getClientJobs = async () => {
    try {
      setLoader(true);
      let getValue = await Getcurrentlocation();
      const payload = {
        PageNumber: 1,
        NrRowsPerPage: 100,
        UserLatitude: getValue?.lat,
        UserLongitude: getValue?.lng,
        ClientId: CLIENT_ID,
        SortBy: sortByNearby ? 1 : 2,
        ClientEmployeeId: selectedClientData?.ClientEmployeeId
      };
      const response = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT, payload, TOKEN);
      if (response.status === 200) {
        let getUpdated = response?.data?.data?.map((item) => {
          return {
            ...item,
            checked: selectedValue?.clientJobCodeId === item?.clientJobId
          };
        });
        setClientJobList(getUpdated ?? []);
      }
    } catch (error) {
      console.error("getClientJobs-> Error ", error);
    } finally {
      setLoader(false);
    }
  };

  const onSelectjob = (e, item) => {
    e.preventDefault();
    setSelectedValue({
      clientEmployeeId: selectedClientData?.ClientEmployeeId,
      clientJobCodeId: item?.clientJobId,
      clientJobUDFieldsList: item?.clientJobUDFieldsList || []
    });
    setFromjob(true);
    setSelectActivities(true);
    onClose();
    setInputValue(`${item.clientJobCode} - ${item.clientJobName} `);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          padding: {
            xs: "10px",
            xl: "15px",
            lg: "15px",
            md: "15px",
            sm: "10px"
          },
          minHeight: "500px"
        }}
        className="client-modal-responsive">
        {loader ? (
          <Stack minHeight={"500px"} alignItems={"center"} justifyContent={"center"} width={"100%"}>
            <Loader />
          </Stack>
        ) : (
          <>
            <Stack
              mb={1}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              flexDirection={"row"}>
              <IconButton onClick={onClose} style={{ padding: "4px" }}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
              <Typography variant="h6">{TEXT_SELECT_JOB}</Typography>
              <Stack
                sx={{ cursor: "pointer" }}
                onClick={() => setSortByNearby((prev) => !prev)}
                flexDirection={"row"}
                gap={0.5}>
                <Typography>{TEXT_SORT_BY}</Typography>
                <Typography sx={{ color: CLIENT_COLOR }}>
                  {sortByNearby ? TEXT_NEAR_BY : TEXT_RECENT}{" "}
                </Typography>
              </Stack>
            </Stack>
            {clientJobList?.length === 0 ? (
              <Stack
                justifyContent="center"
                alignItems="center"
                sx={{ height: "100px", width: "100%", minHeight: "400px" }}>
                <Typography color={BIGrey}>{TEXT_NO_JOBS_FOUND}</Typography>
              </Stack>
            ) : (
              <List style={{ overflow: "scroll", maxHeight: "500px" }}>
                {clientJobList?.map((item) => (
                  <ListItem
                    className="pagelist-content"
                    onClick={(e) => onSelectjob(e, item)}
                    sx={{
                      cursor: "pointer",
                      border: item?.checked
                        ? `1px solid ${CLIENT_COLOR}`
                        : "1px solid rgb(216 216 216)",
                      marginBottom: "10px",
                      borderRadius: "10px"
                    }}>
                    <ListItemText primary={item?.clientJobCode + "-" + item?.clientJobName} />
                  </ListItem>
                ))}
              </List>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default SelectJob;
